import React from "react";

import { Toast } from "react-hot-toast";

export const TOAST_VARIANTS = {
  SUCCESS: "success",
  ERROR: "error",
  LOADING: "loading",
  DEFAULT: "default",
  WARNING: "warning",
} as const;

export const DEFAULT_TOAST_DURATION_MS = 4000;

export const TAKTILE_TEAM_NOTIFIED = "The Taktile team has been notified.";

export type NotificationVariant =
  (typeof TOAST_VARIANTS)[keyof typeof TOAST_VARIANTS];

export type ItemVariant = "success" | "error";

export type ToastMultiStateItem = {
  variant: ItemVariant;
  description: React.ReactNode;
};

type BaseProps = {
  variant: NotificationVariant;
  title: string;
  description?: React.ReactNode;
  items?: ToastMultiStateItem[];
  toastInstance: Toast;
  isDismissible?: boolean;
  onDismiss?: () => void;
};

export type ActionProps = {
  onActionClick: React.MouseEventHandler;
  actionText: React.ReactNode;
};

export type NoActionProps = {
  onActionClick?: never;
  actionText?: never;
};

export type Props = (BaseProps & ActionProps) | (BaseProps & NoActionProps);

type BaseContentProps = {
  variant: NotificationVariant;
  title: string;
  description?: React.ReactNode;
  items?: ToastMultiStateItem[];
  isDismissible?: boolean;
  onDismiss?: () => void;
};

export type ContentProps =
  | (BaseContentProps & ActionProps)
  | (BaseContentProps & NoActionProps);

type BaseParams = {
  id?: string;
  title: string;
  description?: React.ReactNode;
  items?: ToastMultiStateItem[];
  duration?: Nullable<number>;
  isDismissible?: boolean;
  onDismiss?: () => void;
};

export type ToastParams =
  | (BaseParams & ActionProps)
  | (BaseParams & NoActionProps);

export type TrackNotificationArgs = {
  variant: NotificationVariant;
  title: string;
  description?: React.ReactNode;
};
